const endpoints = [
    {
        name: 'sendQuestionToSupport',
        method: 'post',
        path: '/feedback/question',
    },
];

export default endpoints;
